module.exports = __webpack_public_path__ + "img/Oracle_island_raw.5f045083.png";